import { Component, OnInit } from '@angular/core';
import { AllapiService } from 'src/app/allapi.service';

@Component({
  selector: 'app-toronto-nationals',
  templateUrl: './toronto-nationals.component.html',
  styleUrls: ['./toronto-nationals.component.css']
})
export class TorontoNationalsComponent implements OnInit {

  yearname: any = 2019;
  teamPlayers: any = [];
  allResult: any = [];
  teamPlayersStats: any = [];
  teamNameData: any = [];
  yearnameforimage: any = '2024';
  matchroW: any;
  urlRefresh: any;
  deviceStatus: string;
  getInnerHeight(): void {
    this.deviceStatus = this.server.checkSystemWidth();
    console.log('this.deviceStatus :>> ', this.deviceStatus);
  }
  constructor(private server: AllapiService) {

  }

  getSquadJson() {
    if (this.yearnameforimage == '2024') {
      this.teamPlayers = [
    {
        'profileimg': 'Colin Munro.png',
        'PlayerName': 'Colin Munro',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'Romario Shepherd.png',
        'PlayerName': 'Romario Shepherd',
        'Specialization': 'Bowling All Rounder',
    },
    {
        'profileimg': 'Rassie van der Dussen.png',
        'PlayerName': 'Rassie Van der Dussen',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'Muhammad Nawaz .png',
        'PlayerName': 'Md Nawaz',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Rishad Hossain.png',
        'PlayerName': 'Rishad Hossain',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Andries Gous.png',
        'PlayerName': 'Andries Gous',
        'Specialization': 'WK-Batsman',
    },
    {
        'profileimg': 'Junaid Siddique.png',
        'PlayerName': 'Junaid Siddique',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Muhammad Rohid Khan.png',
        'PlayerName': 'Rohid Khan',
        'Specialization': 'Bowler',
    },
    {
        'profileimg': 'Rohit Paudel.png',
        'PlayerName': 'Rohit Paudel',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Saad Bin Zafar.png',
        'PlayerName': 'Saad bin Zafar',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Nicholas Kirton.png',
        'PlayerName': 'Nicholas Kirton',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'Nikhil Dutta.png',
        'PlayerName': 'Nikhil Dutta',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Armaan Kapoor.png',
        'PlayerName': 'Armaan Kapoor',
        'Specialization': 'Wicket Keeper Batter',
    },
    {
        'profileimg': 'Dilraj Deol.png',
        'PlayerName': 'Dilraj Deol',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'matharu.png',
        'PlayerName': 'Jatinder Matharu',
        'Specialization': 'Bowler',
    },
    {
        'profileimg': 'Kanwar Mann.png',
        'PlayerName': 'Kanwar Mann',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'Jagandeep Singh.png',
        'PlayerName': 'Jagandeep Singh',
        'Specialization': 'Batter',
    },
    {
      'profileimg': 'Jason Beherendorff.png',
      'PlayerName': 'Jason Beherendorff',
      'Specialization': 'Bowler',
    },
    {
      'profileimg': 'Roston Chase.png',
      'PlayerName': 'Roston Chase',
      'Specialization': 'Bowling Allrounder',
    },
    {
      'profileimg': 'Unmukt Chand.png',
      'PlayerName': 'Unmukt Chand',
      'Specialization': 'WK-Batsman',
    },
    {
      'profileimg': 'Fabian Allen.png',
      'PlayerName': 'Fabian Allen',
      'Specialization': 'Batting Allrounder',
    }
];

    } else if (this.yearnameforimage == '2023') {
      this.teamPlayers = [
        {
          'profileimg': 'Colin Munro.png',
          'PlayerName': 'Colin Munro',
          'Specialization': 'Batter',
        },
        {
          'profileimg': 'Shahid Afridi.png',
          'PlayerName': 'Shahid Afridi',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Fazalhaq Farooqi.png',
          'PlayerName': 'Fazalhaq Farooqi',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Zaman Khan.png',
          'PlayerName': 'Zaman Khan',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Saim Ayub.png',
          'PlayerName': 'Saim Ayub',
          'Specialization': 'Batter',
        },
        // {
        //   'profileimg': 'Abdullah Shafique.png',
        //   'PlayerName': 'Abdullah Shafique',
        //   'Specialization': 'Batter',
        // },
        {
          'profileimg': 'Hamza Tariq.png',
          'PlayerName': 'Hamza Tariq',
          'Specialization': 'Wicketkeeper Batter',
        },
        {
          'profileimg': 'Gerhard Erasmus.png',
          'PlayerName': 'Gerhard Erasmus',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Johannes Jonathan Smith.png',
          'PlayerName': 'Johannes Jonathan Smit ',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'player-default.png',
          'PlayerName': 'Farhan Malik',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Saad Bin Zafar.png',
          'PlayerName': 'Saad Bin Zafar',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Nicolas Kirton.png',
          'PlayerName': 'Nicholas Kirton',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Armaan Kapoor.png',
          'PlayerName': 'Armaan Kapoor',
          'Specialization': '-',
        },
        {
          'profileimg': 'player-default.png',
          'PlayerName': 'Sarmad Anwar',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Rommel Shahzad.png',
          'PlayerName': 'Rommel Shahzad',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'player-default.png',
          'PlayerName': 'Udhaya Bhagwan',
          'Specialization': '-',
        },
      ];
    } else {
      this.server.getjsonData('teams/stats' + this.yearname + '/toronto_players.json').subscribe(data => {
        this.teamPlayers = data['playerstats'];
      });
    }
  }
  getRsultJson() {
    this.server.getjsonData('results/results_' + this.yearname + '.json').subscribe(data => {
      this.allResult = data['matchsummary'];
      this.allResult.forEach(element => {
        if (element.FirstBattingTeamName == 'TORONTO NATIONALS' || element.SecondBattingTeamName == 'TORONTO NATIONALS') {
          this.teamNameData.push(element)
        }
      });
    });
  }
  getStatsJson() {
    this.server.getjsonData('teams/stats' + this.yearname + '/toronto_players.json').subscribe(data => {
      this.teamPlayersStats = data['playerstats'];
    });
  }


  ngOnInit() {
    this.getInnerHeight();
    this.getSquadJson();
    this.getRsultJson();
    this.getStatsJson();
  }

  SquadData(year) {
    if (year !== '2023') {
      this.yearname = year;
    }
    this.yearnameforimage = year;
    this.teamPlayers = [];
    this.getSquadJson();
  }
  ResultData(year) {
    this.yearname = year;
    this.teamNameData = [];
    this.getRsultJson();
  }
  StatsData(year) {
    this.yearname = year;
    this.teamPlayersStats = [];
    this.getStatsJson();
  }



  ShowPlayer: boolean = true;
  PlayerName: any;
  BowlingType: any;
  BattingType: any;
  Specialization: any;
  profileimg: any;
  Dataforbutton: any;


  Matches: any;
  Innings: any;
  RunsScored: any;
  BallsFaced: any;
  StrikeRate: any;
  BattingAverage: any;
  Bdry4Scored: any;
  Bdry6Scored: any;
  Fifties: any;
  Hundreds: any;
  OversBowled: any;
  TotalRunsConceeded: any;
  WicketsTaken: any;
  BowlingAverage: any;
  Maidens: any;
  BowlingSR: any;
  EconomyRate: any;

  HidePlayer: boolean = false;
  testplyerId: any;
  openTeamPlayer(value) {
    this.getSquadJson();
    for (let data of this.teamPlayers) {
      if (data.PlayerID == value.PlayerID) {
        this.testplyerId = data.PlayerID;
      }
    }
    this.server.topFunction();
    this.ShowPlayer = false;
    this.HidePlayer = true;
    this.Dataforbutton = value;
    this.PlayerName = value.PlayerName
    this.BowlingType = value.BowlingType
    this.BattingType = value.BattingType
    this.Specialization = value.Specialization
    this.profileimg = value.profileimg

    this.OversBowled = value.OversBowled
    this.Matches = value.Matches
    this.RunsScored = value.RunsScored
    // ---------Batting
    this.BattingAverage = value.BattingAverage
    this.StrikeRate = value.StrikeRate
    this.Fifties = value.Fifties
    this.Hundreds = value.Hundreds
    this.Bdry4Scored = value.Bdry4Scored
    this.Bdry6Scored = value.Bdry6Scored
    this.BallsFaced = value.BallsFaced
    this.Innings = value.Innings;
    // ------------Bowlling
    this.TotalRunsConceeded = value.TotalRunsConceeded
    this.WicketsTaken = value.WicketsTaken
    this.BowlingAverage = value.BowlingAverage
    this.EconomyRate = value.EconomyRate
    this.BowlingSR = value.BowlingSR
    this.Maidens = value.Maidens
    this.Innings = value.Innings
  }
  openPlayerDetails(playerDetails) {
    this.matchroW = playerDetails.MatchRow;
    this.urlRefresh = 'https://gt20.in/matchcenter/results?match=' + this.matchroW + '&season=' + this.yearname;
    window.open(this.urlRefresh, "_self");
  }
}
